import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import App from './App.jsx'
import i18n from "./i18n/i18n.js";
import {CssBaseline, ThemeProvider} from "@mui/material";
import theme from "./theme";
import ErrorBoundary from "./errors/error-boundary";

createRoot(document.getElementById('root')).render(
    <ThemeProvider theme={theme}>
        <CssBaseline/>
        <StrictMode>
            <ErrorBoundary>
                <App/>
            </ErrorBoundary>
        </StrictMode>
    </ThemeProvider>
)
